import { Button, Dialog, DialogPanel, DialogTitle } from '@headlessui/react'
import { memo } from 'react'
import { useTranslate } from '../../../hooks/language/use-translate'
import type { UserTaskHostDefault } from '../../../services/users-tasks/defaults/users-tasks-hosts-defaults/types'
import type { UserTaskSpectatorDefault } from '../../../services/users-tasks/defaults/users-tasks-spectators-defaults/types'
import { Reward } from '../components/reward'

interface Props {
  visible: boolean
  task: UserTaskSpectatorDefault | UserTaskHostDefault
  handleCloseModal: () => void
}

export const ModalRescueTask = memo(
  ({ visible, task, handleCloseModal }: Props) => {
    const backgroundUrl =
      'https://pub-3fc85b9f90bf4cf39019f9387ceafd2a.r2.dev/backgrounds/luck-box-background.jpg'

    const { translate } = useTranslate()

    return (
      <Dialog
        open={visible}
        as="div"
        className="absolute top-0 z-10 focus:outline-none"
        onClose={handleCloseModal}
      >
        <div className="z-10 w-screen h-screen flex justify-center items-end">
          <div className="flex w-screen h-screen items-center justify-center bg-black/50">
            <DialogPanel
              transition
              className="mx-4 h-1/2 w-full rounded-xl duration-300 ease-out data-closed:transform-[scale(95%)] data-closed:opacity-0 px-4 py-2 bg-no-repeat bg-center bg-cover flex flex-col"
              style={{ backgroundImage: `url(${backgroundUrl})` }}
            >
              <DialogTitle
                as="h3"
                className="text-xl font-bold text-white text-center"
              >
                {translate('modal-game-gold-miner-congrats')}
              </DialogTitle>

              <div className="mt-10 flex-1 flex items-center justify-center">
                {task?.userTaskBonusType === 'appCoin' && (
                  <Reward coins className="w-32 h-32" />
                )}

                {task?.userTaskBonusType === 'appPoint' && (
                  <Reward points className="w-32 h-32" />
                )}

                {task?.userTaskBonusType === 'appBean' && (
                  <Reward beans className="w-32 h-32" />
                )}

                {!['appCoin', 'appPoint', 'appBean'].includes(
                  task?.userTaskBonusType,
                ) && <Reward gift className="w-32 h-32" />}
              </div>

              <div className="flex flex-row flex-1 items-end justify-center gap-2 mb-5">
                <Button
                  className="inline-flex items-center justify-center gap-2 rounded-md bg-[#4568DC] px-3 py-1.5 text-sm/6 font-semibold text-white shadow-inner shadow-white/10 focus:not-data-focus:outline-none data-focus:outline data-focus:outline-white h-10 w-1/2"
                  onClick={handleCloseModal}
                >
                  Confirmar
                </Button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    )
  },
)
